import _ from 'lodash';
import React from 'react';
import { useFormikContext } from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import useComparable from '~/commons/hooks/useComparable';

import ListResource from '../../lists/ListResource.jsx';
import { isPermitted } from '../../layout/Nav.jsx';

function FieldDesign({ values: { inherit }, status, setValues }) {
  const api = '/api/core/designs';

  return (
    <>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">DESIGN</h6>
      <div className="row">
        <div className="col">
          {isPermitted('designs') && (
            <ListResource
              {...{
                searchable: true,
                api,
                sort: { design: 1 },
                filter: {
                  active: true,
                },
                actions: {
                  create: false,
                  remove: false,
                },
                onRowClick: (row) => {
                  if (status?.disabled) return null;
                  return setValues((v) => ({
                    ...v,
                    design: row,
                    designVariantCode: _.first(row.variation)?.itemCode,
                    ...(v.inherit
                      ? {
                        style: (row.style || []).join(','),
                        color: (row.color || []).join(','),
                        shape: (row.shape || []).join(','),
                        description: row.description,
                      }
                      : {}),
                  }));
                },
                cols: [
                  {
                    key: 'active',
                    sortable: true,
                    getter(v) {
                      return <FA icon={v ? faCheckCircle : faTimesCircle} />;
                    },
                  },
                  { key: 'brand', sortable: true },
                  {
                    key: 'coll.name',
                    children: 'Collection',
                    sortable: true,
                  },
                  { key: 'design', sortable: true },
                  {
                    key: 'gdn',
                    children: 'GDN',
                    sortable: true,
                  },
                ],
              }}
            />
          )}
        </div>

        <div className="col-5">
          <FormGroup label="Design" name="design.design" as="display" />
          <FormGroup label="Collection" name="design.coll.name" as="display" />
          <FormGroup label="Brand" name="design.brand" as="display" />
          <h6 className="small border-bottom text-muted py-1 pt-1 mb-3" />
          <div className="row">
            <div className="col">
              <div className="form-group">
                <label>Inherit</label>
                <FormCheckGroup
                  name="inherit"
                  type="checkbox"
                  label=""
                  asSwitch
                  onClick={(e) => {
                    setValues((v) => ({
                      ...v,
                      ...(e.target.checked
                        ? {
                          style: (v.design.style || []).join(','),
                          color: (v.design.color || []).join(','),
                          shape: (v.design.shape || []).join(','),
                          description: v.design.description,
                        }
                        : {}),
                    }));
                  }}
                />
              </div>
            </div>
          </div>
          <FormGroup name="color" disabled={inherit} />
          <FormGroup name="shape" disabled={inherit} />
          <FormGroup name="style" disabled={inherit} />
          <FormGroup
            name="description"
            as="summernote"
            injectValue
            disabled={inherit}
            options={{
              styleTags: ['p', 'h2', 'h3', 'h4', 'h5', 'h6'],
              toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
                ['view', ['codeview', 'undo', 'redo']],
                ['para', ['paragraph']],
              ],
            }}
          />
        </div>
      </div>
    </>
  );
}

export default () => {
  const { status, setValues, values } = useFormikContext();
  return React.useMemo(() => FieldDesign({ status, setValues, values }), [useComparable(values)]);
};
